import { IValues } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { EField } from "./schema.linkContact.types";

export const getInitialValues = (): IValues => {
  return {
    [EField.Contact]: undefined,
  };
};
